const CARRIERS = {
  '2K':	'Avianca Ecuador',
  '4C':	'LATAM Colombia',
  '4M':	'LATAM Argentina',
  '5D': 'Aerolitoral DBA Aeromexico Connect',
  '7C':	'Jeju Air',
  '9B':	'Accessrail',
  '9W': 'Jet Airways',
  'AA':	'American',
  'AC':	'Air Canada',
  'AE':	'Mandarin Airlines',
  'AF': 'Air France',
  'AM': 'Aeroméxico',
  'AR': 'Aerolineas Argentinas',
  'AS': 'Alaska Airlines',
  'AV': 'Avianca',
  'AZ': 'ITA Airways',
  'BA':	'British Airways',
  'BE':	'FlyBe',
  'CA':	'Air China',
  'CI':	'China Airlines',
  // 'CM': 'Copa Airlines',
  'CS': 'China Southern Airlines',
  'CU':	'Cubana',
  'CX':	'Cathay Pacific',
  'CZ':	'China Southern',
  'DL': 'Delta Air Lines',
  'EK':	'Emirates',
  'EQ':	'TAME',
  'EY':	'Etihad',
  'FM':	'Shanghai Airlines',
  'G3': 'GOL',
  'GA': 'Garuda Indonesia',
  'GU':	'Avianca Guatemala',
  'HA':	'Hawaiian Airlines',
  'HR':	'Hahn Air',
  'IB':	'Iberia',
  'JJ':	'LATAM Brasil',
  'JL': 'Japan Airlines',
  'KA':	'Cathay Dragon',
  'KE': 'Korean Air',
  'KL': 'KLM',
  'KQ': 'Kenya Airways',
  'LA':	'LATAM Airlines',
  'LH':	'Lufthansa',
  'LP':	'LATAM Perú',
  'LR': 'Avianca (Costa Rica)',
  'LX':	'Swiss',
  'LY': 'EL AL Israel Airlines',
  'ME': 'Middle East Airlines',
  'MF':	'Xiamen Air',
  'MU': 'China Eastern Airlines',
  'NZ':	'Air New Zealand',
  'O6': 'Avianca Brasil',
  // 'OK': 'Czech Airlines',
  'OZ': 'Asiana',
  'P5':	'Copa Colombia',
  'PZ': 'LATAM Paraguay',
  'QF': 'QANTAS',
  'RO': 'TAROM',
  'RZ': 'Avianca Costa Rica',
  'SA': 'South African Airways',
  'SK': 'SAS',
  'SQ': 'Singapore Airlines',
  'SU': 'Aeroflot',
  'SV': 'Saudia',
  'T0': 'Avianca (Perú)',
  'TA': 'Avianca (El Salvador)',
  'TK':	'Turkish Airlines',
  'TP':	'TAP Air Portugal',
  'UA':	'United',
  'UX': 'Air Europa',
  'VA': 'Virgin Australia',
  'VN':	'Vietnam Airlines',
  'VS': 'Virgin Atlantic Airways',
  'VW': 'Aeromar',
  'WC':	'Avianca Honduras',
  'WS': 'WestJet',
};
export default CARRIERS;
